<div *ngIf="gavData && gavData.length > 0"
    (finderInViewport)="gav = $event"
    [finderTransitionIn]="gav"
    class="gav-container">
    <h3 class="gav-title" [innerHtml]="gavTitle | safeHtml"></h3>
    <div class="gav-items">
        <a *ngFor="let gavItem of gavData"
            name="&lid={{gavItem.lid}}"
            href="{{gavItem.url}}"
            class="gav-link"
            finderRouterLink
            [analyticsTrackLink]="gavItem.onClick"
            [analyticsTrackSeen]="gavItem.onSeen">
            <finder-picture
                class="gav-image fit"
                [picture]="gavItem.picture">
            </finder-picture>
            <div class="gav-details">
                <div class="gav-name">
                    <span [innerHtml]="gavItem.name | safeHtml"></span>
                    <finder-font-icon name="next-2"></finder-font-icon>
                </div>
                <div class="gav-park"
                    [innerHtml]="gavItem.themePark | safeHtml">
                </div>
            </div>
        </a>
    </div>
</div>
